let stopCheckToken = null;

dsf.mix(dsf, {
  checkTokenTimeout: {
    start() {
      const timeout = dsf.config?.check_token_timeout_time || 5 * 60 * 1000;
      this.stop();
      stopCheckToken = setInterval(() => {
        this._checkToken();
      }, timeout);
    },
    _checkToken() {
      const url = dsf.config?.check_token_timeout_url;
      // const tokenKey = dsf.config?.setting_public_tokenkey || "authorization_token";
      if (url) {
        dsf.http.post(url, {
          token: dsf.getToken(),
        })
          .done((data) => {
            if (data && data.success) {
              return;
            }
            this.stop();
          })
          .catch((error) => {
            console.warn(error);
            this.stop();
          });
      }
    },
    stop() {
      if (stopCheckToken) clearInterval(stopCheckToken);
    },
  },
});
